import {
  Container,
  MenuItem,
  Pagination,
  Typography,
  useMediaQuery,
  // Grid
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import useCategories from "../../hooks/useCategories";
import { axiAuth } from "../../utils/axiosInstance";

import {
  CategoryArea,
  FilterArea,
  MobileFilterBar,
  SolrufTextFieldWhite,
} from "./procurement.style";
import Loader from "../../components/Loader/Loader";
import "./Procurement.css";
import ProcurementProductCard from "./ProcurementProductCard";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setSearchString } from "../../redux/slices/searchSlice";
// import ProductCardForMobile from '../../components/ProductCardForMobile/ProductCardForMobile';
import PageTitle from "../../components/PageTitle/PageTitle";
// import MetaAdder from '../../components/Custom/MetaAdder/MetaAdder';
import { Helmet } from "react-helmet";
import WhatsappShareButtonWithText from "../../components/WhatsappShareButtonWithText/WhatsappShareButtonWithText";
import HomeLeadForm from "../../components/HomeLeadForm/HomeLeadForm";
import PaginationItem from "@mui/material/PaginationItem";
import { Link } from "react-router-dom";
import ProcurementCategories from "./ProcurementCategories";

const Procurement = () => {
  //reading from ViewProduct state slice
  const activeCategoryId = useSelector(
    (state) => state.viewProduct.productCategoryData
  );
  console.log(activeCategoryId);
  const activeSubCategoryId = useSelector(
    (state) => state.viewProduct.productSubCategoryData
  );

  const matchSm = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { register, watch, setValue } = useForm({
    defaultValues: {
      subCategory: activeSubCategoryId,
    },
  });
  const [products, setProducts] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(null);
  const [productsLoading, setProductsLoading] = useState(true);
  const [productsLoadingError, setProductsLoadingError] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialPage = parseInt(searchParams.get("page")) || 1;
  const [page, setPage] = useState(initialPage);
  const dispatch = useDispatch();

  // hook to get categories & sub categories from api
  const { categories } = useCategories("product");

  // console.log(location.pathname)

  // watching the values of selected category and sub category
  const [watchSubCategoryId] = watch(["subCategory"]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // hook to get categories & sub categories from api
  const { subCategories } = useCategories("product", activeCategoryId);

  // selecting the search term from the search box
  const searchTerm = useSelector((state) => state.search.searchTerm);

  // for applying the filters on change of filters values
  useEffect(() => {
    setProductsLoadingError("");
    setProductsLoading(true);
    let url = `api/products?length=15&page=${page}`;

    const searchOptions = {
      category_id: activeCategoryId ? activeCategoryId : 1,
      search: searchTerm || "",
    };

    if (watchSubCategoryId) {
      searchOptions.sub_category_id = watchSubCategoryId;
    }

    axiAuth
      .post(url, searchOptions)
      .then((res) => {
        dispatch(setSearchString(""));
        setProducts(res.data.products);
        setPaginationInfo(res.data.pagination);
        setProductsLoading(false);
        setProductsLoadingError("");
      })
      .catch((err) => {
        setProductsLoadingError(err.message);
        setProductsLoading(false);
      });
  }, [watchSubCategoryId, activeCategoryId, page, dispatch, searchTerm]);

  const [leadFormOpen, setLeadFormOpen] = useState(false);

  useEffect(() => {
    let timer;
    const storageData = JSON.parse(
      localStorage.getItem("leadFormWithVisitShown")
    );
    if (storageData) {
      timer = setTimeout(() => {
        setLeadFormOpen(true);
      }, 7200000);
      return;
    } else {
      localStorage.setItem("leadFormWithVisitShown", true);
      timer = setTimeout(() => {
        setLeadFormOpen(true);
      }, 2000);
    }

    return () => clearTimeout(timer);
  }, []);

  // const handlePaginationChange = (e, newPage) => {
  //    setPage(newPage);
  //    const params = new URLSearchParams(location.search);
  //    params.set('page', newPage);
  //    const newUrl = `${location.pathname}?${params.toString()}`;
  //    history.push(newUrl);
  // };

  return (
    <Box sx={{ background: "#f3f3f3" }} id="products">
      <PageTitle title="Products" />
      <Helmet>
        <meta
          name="title"
          content="Solruf- India’s 1st B2B solar marketplace"
        />
        <meta
          property="og:description"
          content="Check out our Solar products. solruf products"
        />
      </Helmet>
      <CategoryArea>
        <Container>
          <WhatsappShareButtonWithText
            text="In case of enquiry, contact us"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              mb: 2,
            }}
          />
          <Box
            sx={{
              maxWidth: "80%",
              mx: "auto",
            }}
          >
            {categories.length > 0 && (
              <ProcurementCategories
                categories={categories.filter(
                  (category) => category.procurement_filtering
                )}
                // categories={categories}
                setValue={setValue}
              />
            )}
          </Box>
        </Container>
      </CategoryArea>

      <Container>
        <MobileFilterBar sx={{ display: ["block", "block", "none"] }}>
          <SolrufTextFieldWhite
            value={watchSubCategoryId}
            select
            size="small"
            label="Sub Category"
            {...register("subCategory")}
            sx={{
              maxWidth: 300,
            }}
          >
            {subCategories.map(({ category_id, name }) => (
              <MenuItem value={category_id} key={category_id} sx={{}}>
                {name}
              </MenuItem>
            ))}
          </SolrufTextFieldWhite>
        </MobileFilterBar>

        <Grid container spacing={2} justifyContent="center" mt={2}>
          <Grid
            xs={matchSm ? 0 : 3}
            sx={{
              display: ["none", "none", "block"],
            }}
          >
            <FilterArea>
              <Box>
                <SolrufTextFieldWhite
                  value={watchSubCategoryId}
                  select
                  size="small"
                  label="Sub Category"
                  {...register("subCategory")}
                >
                  {subCategories.map(({ category_id, name }) => (
                    <MenuItem value={category_id} key={category_id}>
                      {name}
                    </MenuItem>
                  ))}
                </SolrufTextFieldWhite>
              </Box>
            </FilterArea>
          </Grid>
          <Grid xs={matchSm ? 12 : 9}>
            {/*  ============ products mapping ============ */}

            <Box>
              {productsLoadingError && (
                <Typography
                  color="error"
                  sx={{ textAlign: "center", mt: 5, mb: 4 }}
                >
                  Error fetching products! Try again reloading the page
                </Typography>
              )}
              {productsLoading && <Loader />}

              <Grid
                container
                spacing={matchSm ? 1 : 2}
                sx={{ flexGrow: 1 }}
                justifyContent="center"
              >
                {!productsLoading &&
                  products.length > 0 &&
                  products.map((product, i) => (
                    <Grid xs={12} sm={6} md={4} lg={4} xl={3} key={i}>
                      <ProcurementProductCard
                        product={product}
                        actionType="enquiry"
                      />
                    </Grid>
                  ))}

                {/* If no products are available, then the below code is executed for showing the message. */}
              </Grid>
              {!productsLoading &&
                products.length === 0 &&
                activeCategoryId && (
                  <Box
                    sx={{
                      width: "100%",
                      height: "70vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "1.8rem",
                        "@media (max-width: 900px)": {
                          fontSize: "1.2rem",
                        },
                        color: "rgba(0,0,0,0.3)",
                        padding: "1rem",
                        textAlign: "center",
                      }}
                    >
                      No Product Found in this Category
                    </Typography>
                  </Box>
                )}
              {!productsLoading && products.length > 0 && (
                <Pagination
                  count={paginationInfo?.last_page}
                  page={page}
                  onChange={(e, page) => setPage(page)}
                  color="primary"
                  shape="circle"
                  sx={{
                    "& ul": { justifyContent: "center" },
                    mt: 5,
                    mb: 8,
                  }}
                  renderItem={(item) => (
                    <PaginationItem
                      component={Link}
                      to={{
                        search: `?${new URLSearchParams({
                          ...Object.fromEntries(
                            new URLSearchParams(location.search)
                          ),
                          page: item.page,
                        }).toString()}`,
                      }}
                      {...item}
                    />
                  )}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
      <HomeLeadForm
        open={leadFormOpen}
        onClose={() => setLeadFormOpen(false)}
      />
    </Box>
  );
};

export default Procurement;
